import { createSlice } from "@reduxjs/toolkit";
const detailedPointsSlice = createSlice({
    name: 'detailedPoints',
    initialState: {
        detailedPoints: null
    },
    reducers: {
        setDetailedPoints: (state, action) => {
            state.detailedPoints = action.payload.detailedPoints
        }
    }
});
export const addDetailedPoints = detailedPointsSlice.actions.setDetailedPoints;
export default detailedPointsSlice.reducer;
